var Enum = Enum || { MEEDY : {}};

Enum.MEEDY.TERM_TYPE = {
    EXTERNAL: 'EXTERNAL',
    PRIVATE_TERM: 'PRIVATE_TERM',
    CLAIM: 'CLAIM',
    EXAMINATION: 'EXAMINATION',
    ONLINE_CONSULTATION: 'ONLINE_CONSULTATION',
    TRIP: 'TRIP',
    INTERNAL: 'INTERNAL',
    PRESCRIPTION: 'PRESCRIPTION'
};

Object.freeze(Enum.MEEDY.TERM_TYPE);
